import classNames from "classnames"
import React from "react"
import classes from "./OrderByPanel.module.css"
import CustomButton from "../../../../../ui/atoms/Button"
import { CustomBox } from "../../../../../ui/spacings"
import { isSelected, orderBy, OrderByItem } from "../../../data/sorting"

interface Props {
  current?: OrderByItem
  onChange: (value: OrderByItem) => void
}

const OrderByPanel = ({ current, onChange }: Props) => {
  return (
    <CustomBox minHeight="100vh" px={1} py={3} textCenter>
      {orderBy.map((item) => (
        <CustomBox key={item.id} flex="row" justifyContent="center" my={1.5}>
          {/* <CustomRadioButton size="large" /> */}
          {/* <Typography variant="body1" textClassName={classes.label}>
            {item.label}
          </Typography> */}
          <CustomButton
            variant="text"
            className={classes.button}
            onClick={() => onChange(item.value)}
            invariantCase
          >
            <div
              className={classNames(classes.label, {
                [classes.selected]: current
                  ? isSelected(item.value, current)
                  : false,
              })}
            >
              {item.label}
            </div>
          </CustomButton>
        </CustomBox>
      ))}
    </CustomBox>
  )
}

export default OrderByPanel
